import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SnackbarAction, SnackbarIconConfiguration } from '../../models';

@Component({
  selector: 'evi-mobile-snackbar-action',
  templateUrl: './snackbar-action.component.html',
  styleUrls: ['./snackbar-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SnackbarActionComponent {
  @Input() public action!: SnackbarAction;

  public get icon(): SnackbarIconConfiguration {
    return this.action.icon;
  }

  public get callback(): () => void {
    // NOTE: need to cast as writable to remove the DeepReadonly restriction
    //  to avoid error "Readonly expression: this expression is not callable."
    return this.action.callback as () => void;
  }

  public executeCallback(): void {
    this.callback();
  }
}
